<div class="interface-control__client-intent-toggle__container">
  <div
    [ngClass]="{'interface-control__client-intent-toggle__label': !locked,
					 'interface-control__client-intent-toggle__label--locked': locked}"
  >
    {{data.label}}
  </div>
  <button
    pButton
    type="button"
    (click)="handleIntentChange(!data.intentValue)"
    [label]="data.buttonLabel"
    [disabled]="locked"
    [ngClass]="{
            'bfx-button-oe-sell': data.intentValue && !locked,
            'bfx-button-oe-buy': !data.intentValue && !locked,
            'interface-control__client-intent-toggle__intent-button': true,
            'interface-control__client-intent-toggle__intent-button--sell': data.intentValue && !locked,
            'interface-control__client-intent-toggle__intent-button--buy': !data.intentValue && !locked,
            'interface-control__client-intent-toggle__intent-button--locked': locked
    }"
  ></button>
</div>
